import { c as _c } from "react/compiler-runtime";
import { ErrorBoundary, Provider as RollbarProvider } from '@rollbar/react';
import { getRollbarInstance, rollbarConfig } from 'shared/errorReporter';
import { useAuth } from './AuthContext';
const ErrorProvider = t0 => {
  const $ = _c(6);
  const {
    children,
    FallbackUI
  } = t0;
  const {
    currentUser
  } = useAuth();
  let rollbar;
  if ($[0] !== currentUser) {
    rollbar = getRollbarInstance();
    if (rollbar != null && currentUser?.id != null) {
      rollbar.configure({
        payload: {
          ...rollbarConfig.payload,
          person: {
            id: currentUser.id
          }
        }
      });
    }
    $[0] = currentUser;
    $[1] = rollbar;
  } else {
    rollbar = $[1];
  }
  let t1;
  if ($[2] !== FallbackUI || $[3] !== children || $[4] !== rollbar) {
    t1 = rollbar == null ? <>{children}</> : <RollbarProvider instance={rollbar}><ErrorBoundary fallbackUI={FallbackUI as React.ComponentType<{
        error: Error | null;
        resetError: () => void;
      }>}>{children}</ErrorBoundary></RollbarProvider>;
    $[2] = FallbackUI;
    $[3] = children;
    $[4] = rollbar;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default ErrorProvider;